// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                               from 'firebase/functions';

// ===== Interfaces =====

import {
    IContentsChapterItem,
}                               from '../interfaces';

const getPostContentsTable = async ({
    test,
    postId,
    prevContentsTable,
    expandedChapterIndex,
}: {
    test: boolean,
    postId: string,
    prevContentsTable?: IContentsChapterItem[],
    expandedChapterIndex?: number,
}): Promise<IContentsChapterItem[]> => {
    const functions = getFunctions();
    const handleGetPostContentsTable = httpsCallable<
        Record<
            string,
            boolean | string | number | IContentsChapterItem[] | undefined
        >,
        IContentsChapterItem[]
    >(
        functions,
        'getPostContentsTable',
    );
    return handleGetPostContentsTable({
        test,
        postId,
        prevContentsTable,
        expandedChapterIndex,
    }).then((result) => {
        const contentsTable = result.data as IContentsChapterItem[];
        return contentsTable;
    }).catch((err) => {
        throw err;
    });
};

export default getPostContentsTable;
